import {Table} from "react-bootstrap";
import "./Contacts.css";
import Map from '../components/Map' // import the map here
export function Contacts() {
    const hall = [
        "SSSS Vadtaldham - Chicago",
        "Laxmi Nararyan Dev Gadi (Vadtal)",
        "1402 Arlington Drive",
        "Hanover Park, IL 60133",
        "USA",
    ];

    const data =[
        {name: "Bandish Patel", phone: "(847)414-2858"},
        {name: "Nirav Patel", phone: "(224)558-4528"},
        {name: "Mit Patel", phone: "(224)817-6493"},
        {name: "Dharmesh Patel", phone: "(224)277-0378"},
    ];

    return (
        <div className = "parent">
            <div className ="container">
                <div className="side">
                    <p> <b>Address:</b></p>
                    <Table>
                        {hall.map((item,index) => (
                            <tr key={index}>
                                {/*<td width={"2%"}></td>*/}
                                <td align="left">{item}</td>
                            </tr>
                        ))}
                    </Table>
                    <p><b>For more information, please contact:</b></p>
                    <Table>
                        {data.map((item,index) => (
                            <tr key={index}>
                                {/*<td width={"2%"}></td>*/}
                                <td align="left">{item.name}</td>
                                <td align="left">{item.phone}</td>
                            </tr>
                        ))}
                    </Table>
                </div>
                <div className="side side-content-center">
                    <Map />
                </div>
            </div>
        </div>
    );
}
